import {
    useAppSidePanelContextProvider
} from "../../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import { PortfolioSettingsModel } from "../../../portfolio-info/types/PortfolioSettingsModel";
import { portfolioMappers } from "../../../../shared/mappers/PortfolioMappers";
import { Fragment, useState } from "react";
import { Box, ToggleButton, Tooltip } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import { ChartSettingsDialog } from "./ChartSettingsDialog";

export function ChartSettingsButton() {
    const {
        selectedPortfolio,
        saveSelectedPortfolio,
        updateSelectedPortfolio,
    } = useAppSidePanelContextProvider();

    const [isEditPortfolioSettingsDialogOpen, setIsEditPortfolioSettingsDialogOpen] = useState<boolean>(false);
    const [submitEditedPortfolioSettings, setSubmitEditedPortfolioSettings] = useState<(portfolioModel: PortfolioSettingsModel) => void>();
    const [editingPortfolioSettingsModel, setEditingPortfolioSettingsModel] = useState<PortfolioSettingsModel | null>(null);

    const handleOpenEditChartSettingsDialog = () => {
        if (selectedPortfolio === null || selectedPortfolio.portfolioSettings === null) {
            return;
        }

        setEditingPortfolioSettingsModel({...selectedPortfolio.portfolioSettings});

        setSubmitEditedPortfolioSettings(() => async (updatedModel: PortfolioSettingsModel): Promise<void> => {
            selectedPortfolio.portfolioSettings = portfolioMappers.mapSettingsModelToModel(updatedModel);
            await updateSelectedPortfolio();
            await saveSelectedPortfolio();
        });

        setIsEditPortfolioSettingsDialogOpen(true);
    };
    
    return (
        <>
            <ChartSettingsDialog
                isOpen={isEditPortfolioSettingsDialogOpen}
                setIsOpen={setIsEditPortfolioSettingsDialogOpen}
                submitAction={submitEditedPortfolioSettings}
                editingModel={editingPortfolioSettingsModel}
                icon={<SettingsIcon/>}
            />
            <Tooltip
                placement="bottom-start"
                disableInteractive
                arrow
                componentsProps={{
                    tooltip: {
                        sx: {
                            maxWidth: '500px'
                        },
                    },
                }}
                slotProps={{
                    popper: {
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, 2],
                                },
                            },
                        ],
                    },
                }}
                title={
                    <Fragment>
                        <Box sx={{fontSize: "13px"}}>
                            Chart settings
                        </Box>
                    </Fragment>
                }
            >
                <ToggleButton
                    value="check"
                    selected={true}
                    color="standard"
                    onChange={() => handleOpenEditChartSettingsDialog()}
                    sx={{
                        borderColor: "#9e9d9d",
                        marginTop: '10px',
                        marginLeft: '-20px',
                        height: '5px',
                        width: '5px',
                        '&.Mui-selected': {
                            backgroundColor: '#cdcdcd',
                        },
                    }}
                >
                    <SettingsIcon sx={{
                        height: '18px',
                        width: '18px',
                    }} />
                </ToggleButton>
            </Tooltip>
        </>
    );
}